import workspaceQuery from 'graphql/queries/supplier/SupplierGlobalAmendResultsWorkspaceQuery.graphql';
import instanceQuery from 'graphql/queries/supplier/SupplierGlobalAmendQuery.graphql';
import { EntityType } from '../../../@types/entityTypes';

const SupplierGlobalAmendResult: EntityType = {
  type: 'SupplierGlobalAmendResult',
  title: 'Supplier Global Amendment Results',
  formTitle: 'Supplier Global Amendment Result',
  workspaceUrl: '/Suppliers/SupplierGlobalAmendResultDetails/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  screenReference: 'SUPPLIERS_GLOBAL_AMENDMENTS',
};

export default SupplierGlobalAmendResult;
